import axios from 'axios';
import qs from 'qs';
import that from '../main';
import {
    hideLoading
} from '../common/plugins/loading';

const $http = axios.create({
    // 开发环境
    // timeout: 20000,
    responseType: 'json',
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
    }
});

// 请求qs序列化;
$http.interceptors.request.use(
    config => {
        if (
            config.headers['Content-Type'] ===
            'application/x-www-form-urlencoded'
        ) {
            config.data = qs.stringify(config.data, {
                arrayFormat: 'indices',
                allowDots: false
            });
        }
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const token_ptk = sessionStorage.getItem('token_ptk');
        if (token_ptk) {
            config.headers['Platform-Token'] = token_ptk;
        }
        return config;
    },
    error => {
        that.$message.error(error && error.data.error_msg);
        return Promise.reject(error.data.error_msg);
    }
);

// 接收数据，刷新token，封装res
$http.interceptors.response.use(
    res => {
        switch (res.status) {
            case 401:
                hideLoading();
                localStorage.clear();
                that.$router.push({
                    path: '/login',
                    query: {
                        ref: location.href
                    }
                });
                break;
            case 200:
                hideLoading();
                const {
                    errcode, errmsg
                } = res.data;
                if (errcode !== 0 && errmsg) {
                    that.$message.error(errmsg);
                }

                return res.data;
            case 500:
                hideLoading();
                that.$message.error(
                    'Internal server error.'
                );
                break;
            default:
                //其他默认返回的blob文件流
                hideLoading();
                return res.data;
        }
    },
    error => {
        hideLoading();

        if (error.response && error.response.status === 401) {
            localStorage.clear();
            // that.$router.push({
            //     path: '/login',
            //     query: {
            //         ref: location.href
            //     }
            // });
            location.href = '/login?ref=' + encodeURIComponent(location.href);
            return false;
        }

        that.$message.error(
            'The request timed out. Please check the network.'
        );
    }
);

/**
 * Api列表
 */

const pathList = {
    // 用户登录
    login: '/sale/login',
    // 退出登录
    logout: '/sale/logout',
    // 用户注册
    register: '/sale/user/register',
    // 验证邮件验证码
    verifyEmailCode: '/sale/user/verify-email-code',
    // 创建用户
    createUser: '/sale/user/create',
    // 菜单列表
    menu: '/system/menu',
    //设置菜单中列表tabs
    menuSetStatus: '/system/menu/addstatus',
    //获取菜单中列表tabs
    menuGetStatus: '/system/menu/getstatus',
    //获取菜单中tabs下拉
    menuSelectStatus: '/system/menu/selectstatus',
    // 登录获取导航菜单
    authority: '/sale/authority',
    newAuthority: '/sale/authority/nav',
    // 订单列表
    orders: '/sale/order',
    // 订单列表
    shop: '/sale/shop',
    // 店铺下拉列表
    shopSelect: '/sale/shop/select',
    // 平台列表
    platform: '/sale/platform',
    // 平台下拉列表
    platformSelect: '/sale/platform/select',
    // 店铺授权
    shopAuth: '/sale/shop/auth',
    // 上传到站点
    uploadToSite: '/system/upload-one-img',
    // oss token
    ossToken: 'https://oss-cmo.loratech.cn/upload-token',
    // 物品 - 重量导入
    goodsBatchUpdateWeight: [
        '/sale/goods/batch-update-weight',
        {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ],
    // 商品分类 
    productList: '/sale/goods',
    productDetail: '/sale/goods',
    productCategory: '/sale/category',
    // shopify刊登列表
    shopifyListing: '/sale/shopifyListing',
    // 批量删除
    shopifyListingDel: '/sale/shopifyListing/batchDelete',
    // shoplazza刊登列表
    shoplazzaListing: '/sale/shoplazzaListing',
    // shoplazza批量删除
    shoplazzaListingDel: '/sale/shoplazzaListing/batchDelete',
    // shopline刊登列表
    shoplineListing: '/sale/shoplineListing',
    // shopline批量删除
    shoplineListingDel: '/sale/shoplineListing/batchDelete',
    // 刊登批次列表
    listingRecord: '/sale/listingRecord',
    // 刊登批次明细
    listingRecordDetail: '/sale/listingRecord/detail',
    // 单个刊登
    singlePublication: '/sale/goods/display',
    // 批量刊登
    batchPublication: '/sale/goods/batchDisplay',
    // 货币下拉列表
    currencySelect: '/sale/currency/select',
    // 添加到购物车 
    addShoppingCart: '/sale/shoppingCart',
    // 购物车列表 
    shoppingCartList: '/sale/shoppingCart',
    // 产品下载列表
    downloadList: '/sale/goodsDownload',
    // 产品下载
    goodsDownload: '/sale/goodsDownload/down',
    download: '/sale/goodsDownload/export',
    batchDownload: '/sale/goodsDownload/batchDownload',
    // 用户地址 
    userAddress: '/sale/userAddress',
    // 国家下拉 
    countrySelect: '/sale/country/select',
    // 产品收藏 
    collectionList: '/sale/collection',
    // 批量产品收藏 
    batchCollection: '/sale/collection/batchCreate',
    // 创建外部链接
    createExternalLink: '/sale/collection/createExternalLink',
    // 外部链接(自己)
    getExternalLinks: '/sale/collection/externals',
    // 外部链接reset
    externalReset: '/sale/collection/reset',
    // 删除外部链接
    externalDel: '/sale/collection/deleteExternalLink',
    // 外部链接列表
    externalLinkList: '/sale/externalLink',
    // 下单
    placeOrder: '/sale/order',
    // 支付
    placeOrderPay: '/sale/order/pay',
    // 主体信息
    entityInfo: '/sale/user/entityInfo',
    // 待发货转发货中
    shipment: '/sale/order/processing',
    // 按天统计订单信息
    statByDays: '/sale/order/statByDays',
    // 修改订单地址
    orderUpdateAddress: '/sale/order/updateAddress',
    // 物流方式
    shippingMethod: '/sale/shipping/select',
    // 交易明细
    transactionDetails: '/sale/transactionDetails',
    // 首页数据
    homeData: '/sale/home',
    // 订单列表更新物流渠道
    updateShipping: '/sale/order/shipping',
    // 充值 
    recharge: '/sale/recharge',
    // 提现
    withdrawal: '/sale/withdrawal',
    // 定制信息 
    customizedSetting: '/customized/setting',
    customized: '/customized',
    // 用户主体
    saleUserList: '/sale/user/list',
    // 企业主体  
    saleEntityList: '/sale/entity',
    // 主体等级下拉
    entityRankSelect: '/sale/entityRank/select',
    // 邀请码列表 
    businessCode: '/sale/businessCode',
    // 邀请码选择
    businessCodeSelect: '/sale/businessCode/select',
    // 批量订单数据 
    saleOrderList: '/sale/order/orderList',
    // 批量支付 
    batchPay: '/sale/order/batchPay',
    // 批量取消
    batchOrderCancel: '/sale/order/cancel',
    // 批量转异常 
    batchOrderAbnormal: '/sale/order/abnormal',
    // 用户等级 
    entityRank: '/sale/entityRank',
    // 物流方式 
    expressList: '/sale/shipping',
    // 物流渠道 
    expressSelect: '/sale/channel/select',
    // Lastmile
    lastMileSelect: '/sale/lastMile/select',
    // 更新尾程物流
    lastMileExpressUpdate: '/sale/lastMile/updateExpress',
    // 导入订单
    orderImport: '/sale/orderImport/process1',
    orderImport2: '/sale/orderImport/process2',
    orderImport4: '/sale/orderImport/process4',
    importTrack: '/sale/orderImport/processTrackingNo',
    // 订单模板下载 
    orderTpl1: '/sale/orderImport/tpl1',
    orderTpl2: '/sale/orderImport/tpl2',
    orderTpl4: '/sale/orderImport/tpl4',
    // 产品集 
    productsSetList: '/sale/goodsSet',
    // 产品集导出
    productsSetExport: '/sale/goodsSet/export',
    // 产品导入 
    productsImport: '/sale/goods/import',
    // 首页 订单统计 
    orderAnalysis: '/sale/orderAnalysis',
    // 订单重发信息
    orderRedeliver: '/sale/order/getRedeliverList',
    // 定制选项 
    metafiledsSelect: '/sale/metafileds/select',
    // 产品集列表 
    metafileds: '/sale/metafileds',
    // 按店铺统计 
    statForShop: '/sale/orderAnalysis/statForShop',
    // 订单导出 
    orderExport: '/sale/order/export',
    // 报告导出 
    reportExport: '/sale/order/report',
    // 产品集批量上下架 
    goodsSetBatchUpdateStatus: '/sale/goodsSet/batchUpdateStatus',
    // 产品集批量设置时间
    setProcessingTime: '/sale/goodsSet/setProcessingTime',
    // 产品集批量设置组合产品
    setCombineSku: '/sale/goodsSet/setCombineSku',
    // 角色下拉 
    roleSelect: '/sale/role/select',
    // 重置密码  
    resetPassword: '/sale/password/reset',
    // 邮箱验证码 
    verificationEmailCode: '/sale/password/verificationCode',
    // 我的下载 
    orderMyDownload: '/sale/myDownload',
    // 订单下载url 
    orderDownload: '/sale/myDownload/fetch',
    // 修改订单产品 
    orderUpdateGoods: '/sale/order/updateGoods',
    // 仓库进度
    wmsSteps: '/erp/wms-steps',
    // sku映射列表 
    skuTemp: '/sale/skuTemp',
    // 物流渠道列表 
    channel: '/sale/channel',
    // 更新购物车产品数 
    shoppingCartChangeNum: '/sale/shoppingCart/changeNum',
    // 退款 
    orderRefund: '/sale/order/refund',
    // 修改订单价格 
    orderChangeActAmount: '/sale/order/changeActAmount',
    // 角色权限
    role: '/sale/role',
    // 私域产品列表
    privateProducts: '/sale/privateProducts',
    // 按用户邮箱统计订单 
    statForShopUser: '/sale/orderAnalysis/statForShopUser',
    goodsCategory: '/sale/catalog',
    goodsCategorySelect: '/sale/catalog/select',
    // 产品标签下拉
    goodsTagsSelect: '/sale/goodsTags/select',
    // 私域产品编辑
    privateProducts: '/sale/privateProducts',
    // 用户下拉
    userSelect: '/sale/user/select',
    // 产品标签
    goodsTags: '/sale/goodsTags',
    // 订单备注 
    orderRemark: '/sale/order/remark',
    // 根据平台单号删除订单 
    orderCustomDelete: '/sale/order/customDelete',
    // Ioss列表 /sale/ioss
    iossList: '/sale/ioss',
    iossSelect: '/sale/ioss/select',
    // 优惠券 
    couponList: '/sale/coupon',
    // 地址薄
    addressBook: '/sale/userAddress',
    // 优惠券 
    couponSelect: '/sale/coupon/select',
    // 我的优惠劵 
    userCoupon: '/sale/user/coupon',
    // 货币列表 
    currencyList: '/sale/currency',
    // 充值审核列表 
    rechargeExamine: '/sale/offlinePay',
    // 店匠单个刊登 
    singleShoplazzaPublication: '/sale/goods/shoplazzaDisplay',
    // 修改物流渠道 
    updateTrackno: '/sale/order/updateChannelCodeAndTrackno',
    // 下单时信息(物流, ioss, 优惠劵, 保险) 
    orderPlaceInfo: '/sale/order/placeInfo',
    // 菜单分类下拉 
    menuSelectCategory: '/system/menu/selectCategory',
    // 订单自动加SKU
    shopOrderSku: '/sale/shopOrderSku',
    // 订单自动加备注
    shopOrderRemark: '/sale/shopOrderRemark',
    // 统计
    entityAnalysis : '/sale/corpEntityAnalysis',
    // 
    couponNotify: '/sale/coupon/notify',
    // 尾程列表
    lastMile: '/sale/lastMile',
    // 节日产品列表
    holiday: '/sale/holiday',
    // 我的店铺
    myStore: '/sale/shop/mystore',
    // 授权后绑定店铺
    bindStore: '/platform/bind',
    // 引导页点赞
    diggGuide: '/sale/home/set-guide-helpful',
    // 跳过引导页
    skipGuide: '/sale/home/skip-guide',
    // 设置用户通知
    setNotice: '/sale/user/setNotice',
    // 获取用户通知
    getNotice: '/sale/user/getNotice',
    // 运费规则
    shippingRule: '/sale/shippingRule',
    // 获取跟踪人姓名和联系邮箱
    getContactUser: '/sale/user/contact',
    //  批量更新用户BusinessCode和DeliveryTag
    changeBusinessCodeAndDeliveryTag: '/sale/user/changeBusinessCodeAndDeliveryTag',
    // 下载发票
    orderPrint: '/sale/order/prinfPdf',
    // shipped passback
    orderPassBack: '/sale/order/rePassBack',
};

const cmofferApi = {};
for (let key in pathList) {
    let options = pathList[key];
    let path = options;
    if (options instanceof Array) {
        path = options[0];
        options = options[1];
    } else {
        options = {};
    }
    const url = (!/^https?:\/\//.test(path) && process.env.VUE_APP_BASE_API || '') + path;
    /* console.log('url: ', url.length, url.lastIndexOf('/'));
    console.log('url: ', url); */
    cmofferApi[key] = (params, method = 'get', id = '', reqOptions = {}) => {
        if (reqOptions) {
            options = Object.assign(options, reqOptions);
        }
        return $http[method](
            `${url}${id && `/${id}` || ''}`,
            'get' === method.toLowerCase() && {
                params
            } || params,
            options
        );
    };

    // url 用于自由组装请求
    cmofferApi[`${key}_url`] = url;
}

export {
    cmofferApi
};